/**
 * The frame around the kitchen display, which is the thinnest of the three.
 *
 * This is a screen on a wall. It is set up once and then watched — nobody
 * navigates from it, and every pixel spent on chrome is a pixel not spent on
 * tickets. So there is a strip with the logo and a way out, and nothing else.
 *
 * The old interface put the full 256px sidebar here. On a wall display that is
 * a quarter of the screen given over to links nobody in the kitchen will ever
 * press.
 */
import { Outlet, useNavigate } from 'react-router-dom';

import { useAuth } from '../../stores/auth.js';
import logo from '../../assets/logo.png';

export function KitchenShell() {
  const navigate = useNavigate();
  const can = useAuth((s) => s.can);
  const signOut = useAuth((s) => s.signOut);

  return (
    <div className="flex h-dvh flex-col">
      <header className="flex h-11 shrink-0 items-center gap-3 border-b border-rule bg-surface px-3">
        <img src={logo} alt="Food Run" className="h-5 w-auto shrink-0" width="512" height="97" />
        <span className="text-sm font-medium text-ink-2">Kitchen</span>

        <div className="flex-1" />


        {can('pos.create.pos') && (
          <button
            onClick={() => navigate('/pos')}
            className="rounded-lg px-2.5 py-1.5 text-xs font-medium text-ink-3 hover:bg-surface-3 hover:text-ink-2"
          >
            Till
          </button>
        )}

        <button
          onClick={signOut}
          className="rounded-lg px-2.5 py-1.5 text-xs font-medium text-ink-3 hover:bg-surface-3 hover:text-ink-2"
        >
          Sign out
        </button>
      </header>

      <main className="min-h-0 flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
}
